export function clearSession(){
    return dispatch => {
        dispatch({
            type: "CLEAR_SESSION"
        });
    }
}